import React from 'react'
import { ReactSelect } from '@softura/customcomponent'
import './index.scss'

interface IProps {
  className?: string,
  options?:any,
  isMulti?:any,
  'data-attribute'?: any,
}

const MultiselectContainer = ({className, isMulti, options, 'data-attribute': dataAttribute}:IProps) => {
  return (
    <ReactSelect
      className = {`multiselect-input ${className}`}
      isMulti = {isMulti}
      options = {options}
      data-attribute={dataAttribute}
    >
    </ReactSelect>
  )
}

export default MultiselectContainer
